module.exports = __webpack_public_path__ + "static/step-1-79c8ea2d4ce199572b9b84443dd432ec.png";